module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.5b3ad248.eot";